import { render, staticRenderFns } from "./addressMana.vue?vue&type=template&id=085a538c&scoped=true"
import script from "./addressMana.vue?vue&type=script&lang=js"
export * from "./addressMana.vue?vue&type=script&lang=js"
import style0 from "./addressMana.vue?vue&type=style&index=0&id=085a538c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085a538c",
  null
  
)

export default component.exports